export const getRecentProcurementIds = (uid: string): string[] => {
  if (!uid) {
    return [];
  }
  try {
    const data = localStorage.getItem(`recent_procurements_${uid}`);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const markProcurementVisited = (uid: string, procurementId: string) => {
  if (!uid || !procurementId) {
    return;
  }
  const recent = getRecentProcurementIds(uid);
  const newRecent = [procurementId, ...recent.filter((id) => id !== procurementId)].slice(0, 3);
  localStorage.setItem(`recent_procurements_${uid}`, JSON.stringify(newRecent));
  window.dispatchEvent(new Event('recentProcurementsUpdated'));
};

export const removeRecentProcurement = (uid: string, procurementId: string) => {
  if (!uid || !procurementId) {
    return;
  }
  const recent = getRecentProcurementIds(uid);
  const newRecent = recent.filter((id) => id !== procurementId);
  localStorage.setItem(`recent_procurements_${uid}`, JSON.stringify(newRecent));
  window.dispatchEvent(new Event('recentProcurementsUpdated'));
};
